import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70841544"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "info" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "wrapper" }
const _hoisted_8 = { class: "help-wrapper" }
const _hoisted_9 = { class: "left" }
const _hoisted_10 = { class: "d-aside" }
const _hoisted_11 = { class: "d-aside__main-menu" }
const _hoisted_12 = { class: "right" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-close" }, null, -1))
const _hoisted_14 = { class: "info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_desktop_header = _resolveComponent("desktop-header")!
  const _component_drive_aside_main_menu = _resolveComponent("drive-aside-main-menu")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_app_header, { class: "header" }, {
            "top-left": _withCtx(() => [
              _createVNode(_component_router_link, {
                to: "/settings",
                class: "back-link"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            "top-middle": _withCtx(() => [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$localize('settings.help.title')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$localize('settings.help.info')), 1)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_desktop_header),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("aside", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_drive_aside_main_menu)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_router_link, {
                to: "/settings",
                class: "close"
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$localize('settings.help.info')), 1)
            ])
          ])
        ])
      ]))
}